<template>
  <div class="member-list">
    <div class="table-search">
      <el-form :inline="true" ref="form" :model="form" class="form-inline">
        <div>
          <el-form-item label="姓名：" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="userPhone">
            <el-input v-model="form.userPhone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="积分范围：" prop="region">
            <el-select placeholder="请选择" v-model="form.region">
              <el-option
                v-for="item in options"
                :key="item.label"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="date">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="addMember">新增</el-button>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        header-cell-class-name="headerBg"
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="微信头像" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.avatarUrl" alt />
          </template>
        </el-table-column>
        <el-table-column prop="nickName" align="center" label="微信名称"></el-table-column>
        <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="userIntegral" label="积分" align="center"></el-table-column>
        <el-table-column prop="buyNum" label="购买次数" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="view" @click="handleView(scope.row.id)">查看</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { getUserList, excelPort } from '@/api/prefer';
import Pagination from '@/components/Pagination';
import Excel from '@/mixins/export';

export default {
  mixins: [Excel],
  data() {
    return {
      form: {
        userName: null,
        region: {
          value: {
            integralMin: '',
            integralMax: '',
          },
        },
        userPhone: null,
        date: '',
      },
      tableData: [],
      options: [
        {
          id: 0,
          value: {
            integralMin: '',
            integralMax: 100,
          },
          label: '100以下',
        },
        {
          id: 1,
          value: {
            integralMin: 100,
            integralMax: 300,
          },
          label: '100~300',
        },
        {
          id: 2,
          value: {
            integralMin: 300,
            integralMax: 600,
          },
          label: '300~600',
        },
        {
          id: 3,
          value: {
            integralMin: 600,
            integralMax: 900,
          },
          label: '600~900',
        },
        {
          id: 4,
          value: {
            integralMin: 900,
            integralMax: 1500,
          },
          label: '900~1500',
        },
        {
          id: 5,
          value: {
            integralMin: 1500,
            integralMax: 2000,
          },
          label: '1500~2000',
        },
        {
          id: 6,
          value: {
            integralMin: 2000,
            integralMax: '',
          },
          label: '2000以上',
        },
      ],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 3,
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    // 参数处理
    DealParameter() {
      const { region, date, ...rest } = this.form;
      const { integralMin, integralMax } = region.value;
      const [beginTime, endTime] = date;
      return {
        ...rest,
        integralMin,
        integralMax,
        beginTime,
        endTime,
      };
    },
    getUserList() {
      this.loading = true;
      const data = this.DealParameter();
      return getUserList({
        ...data,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
        } else {
          this.$message.error(res.message);
        }
        return false;
      });
    },
    // 输入查询
    handleInputChange() {
      this.getUserList();
      this.currentPage = 1;
    },
    // 导出
    handleExport() {
      const data = this.DealParameter();
      excelPort(data).then((res) => {
        this.exportExcel(res, '会员列表');
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getUserList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getUserList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 查看
    handleView(id) {
      this.$router.push({
        name: 'PreferDetail',
        query: {
          id,
        },
      });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'PreferEditor',
        query: {
          id,
        },
      });
    },
    addMember() {
      this.$router.push({
        name: 'PreferAdd',
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.form-inline
  flex-row()
  justify-content space-between
.view, .editor
  color #1890ff
  cursor pointer
.view
  margin-right 20px
img
  width 50px
  height 50px
</style>
